<template>
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn active">申报评估考核阶段</div>
        <div class="btn" @click="toPath">历史文件库</div>
      </div>
    </template>
    <template v-slot:nav_right>
      <div v-if="!empty" class="yioks_btn" @click="handleSaveTemp">
        临时保存
      </div>
      <!-- <div v-if="!empty" class="yioks_btn" @click="handleAll">完成并提交</div> -->
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <template v-if="!empty && !loading">
              <div class="nav-btn left-btn" v-if="isShowQueryBtn">
                <el-button
                  type=""
                  size="small"
                  icon="el-icon-arrow-left"
                  @click="handleLeft"
                ></el-button>
              </div>
              <div class="" :class="isShowQueryBtn ? 'tag-box' : 'tag-box1'">
                <vue-scroll :ops="opsHorizontal" ref="scrollDom">
                  <div class="scroll-wrapper" ref="scrollWrapper">
                    <el-button type="" size="small" @click="toUploadHome"
                      >首页</el-button
                    >
                    <el-button
                      :type="item == currentQuery ? 'primary' : ''"
                      size="small"
                      v-for="(item, index) in queryList"
                      :key="index"
                      @click="changeNav(item)"
                      >{{ item }}</el-button
                    >
                  </div>
                </vue-scroll>
              </div>
              <div class="nav-btn right-btn" v-if="isShowQueryBtn">
                <el-button
                  type=""
                  size="small"
                  icon="el-icon-arrow-right"
                  @click="handleRight"
                ></el-button>
              </div>
            </template>
          </div>
          <div class="list_wrap" v-if="!empty && !loading">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th stageName">评估考核指标名称</div>
                  <template v-if="isInClubSystem">
                    <div class="th targetTotalScore">分值</div>
<!--                    <div class="th score">自评得分</div>-->
                  </template>
                  <template v-if="isInClubSystem">
                  <div class="th targetRemark">指标建议</div>
                  </template>
                  <template v-else>
                    <div class="th targetRemark1">指标建议</div>
                  </template>
                  <div class="th action">操作</div>
                  <div class="th targetSuggest">提交状态</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in showPageList"
                        :key="index + 'tar'"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td stageName doubleTitle">
                          <template v-if="isInClubSystem">
                            <p
                              :title="`【${item.targetSecondlyName}】`"
                              class="upTitle"
                            >
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                          <template v-else>
                            <p :title="item.targetSecondlyName" class="upTitle">
                              【{{ item.targetSecondlyName }}】
                            </p>
                            <p :title="item.targetThirdlyName">
                              {{ item.targetThirdlyName }}
                            </p>
                          </template>
                        </div>
                        <template v-if="isInClubSystem">
                          <div class="td targetTotalScore">
                            <p>0 ~ {{ item.targetSecondlyTotalScore }}</p>
                          </div>
<!--                          <div class="td score">-->
<!--                            <p>{{ item.score | empty }}</p>-->
<!--                          </div>-->
                        </template>

                        <template v-if="isInClubSystem">
                        <div
                          class="td targetRemark"
                          :title="item.targetSecondlyRemark"
                        >
                          <p style="width: 100%">
                            {{ item.targetSecondlySuggest }}
                          </p>
                        </div>
                        </template>
                        <template v-else>
                          <div
                            class="td targetRemark1"
                            :title="item.targetSecondlyRemark"
                          >
                            <p style="width: 100%">
                              {{ item.targetSecondlySuggest }}
                            </p>
                          </div>
                        </template>
                        <div class="td action">
                          <p>
                            <template v-if="item.canEdit">
                              <template v-if="!item.submit">
                                <span
                                  class="item"
                                  @click="handleCheckTarget(item)"
                                  >提交</span
                                >
                              </template>
                              <template v-else>
                                <span class="item" @click="handleEditRow(item)"
                                  >编辑</span
                                >
                              </template>
                            </template>
                            <template v-else>
                              <template v-if="!item.submit">
                                <span
                                  class="un-submit"
                                  :title="'材料已通过，无需重复提交'"
                                  >已通过</span
                                >
                              </template>
                              <template v-else>
                                <span
                                  class="un-edit"
                                  :title="'材料已通过，无需重复提交'"
                                  >已通过</span
                                >
                              </template>
                            </template>
                          </p>
                        </div>
                        <div class="td targetSuggest">
                          <p :class="{ active: item.submit || !item.canEdit }">
                            {{
                              item.canEdit
                                ? item.submit
                                  ? "已提交"
                                  : "未提交"
                                : "审核通过"
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
              <div class="footer-tips">
                <template v-for="(item, i) in tongji">
                  <span
                    :key="i + '1'"
                    v-if="item.targetName === currentQuery"
                    style="margin-right: 10px"
                  >
                    {{ item.targetName }}已提交:{{ item.ok }}项 ;
                  </span>
                  <span
                    :key="i + '2'"
                    v-if="item.targetName === currentQuery"
                    style="margin-right: 10px"
                  >
                    {{ item.targetName }}未提交:{{ item.total - item.ok }}项 ;
                  </span>
                  <span
                    :key="i + '3'"
                    v-if="item.targetName === currentQuery"
                    style="margin-right: 10px"
                  >
                    {{ item.targetName }}完成:{{
                      ((item.ok / item.total) * 100).toFixed(0)
                    }}% ;
                  </span>
                </template>
                <span style="margin-right: 10px"
                  >总进度： {{ tongjiAll }}% ;</span
                >
<!--                <span v-if="isInClubSystem"> 自评总得分：{{ totalScore }}</span>-->
              </div>
            </div>
          </div>
          <template v-if="isUpload">
            <upload-dialog
              :isOpen.sync="isUpload"
              :defaultFormData="editRow"
              :isEdit="isEditMode"
              :stageUuid="stageUuid"
              @closeDialogCallBack="handleUploadCallBack"
            ></upload-dialog>
          </template>

          <template v-if="isUploadAll">
            <yioks-tip
              :showTip="isUploadAll"
              :tipMsg="
                isAllSubmited
                  ? '请确定是否完成并提交？提交后仍可撤回修改'
                  : '存在未提交的项目，请确定是否继续提交？提交后仍可撤回修改'
              "
              @callback="handleUploadCallBackAll"
            ></yioks-tip>
          </template>
          <template v-if="isShowSaveTemp">
            <yioks-tip
              :showTip="isShowSaveTemp"
              tipMsg="确定临时保存当前数据，后续仍可继续完善"
              @callback="handleConfirmSaveTemp"
            ></yioks-tip>
          </template>

          <yioks-empty v-if="empty" tips="暂时没有数据"></yioks-empty>
          <yioks-loading v-if="loading"></yioks-loading>
        </div>
        <!-- <yioks-pagination :total="total" :page.sync="page"></yioks-pagination> -->
      </div>
    </template>
  </yioks-content>
</template>

<script>
import { getTargetListForSubmit, postTargetSumitAll } from "@/api/performance";
import { opsHorizontal } from "@/utils/scrollIndialog";
import storage from "@/utils/storage";
import mixinAppConfig from "@/mixin/mixinAppConfig";

export default {
  mixins: [mixinAppConfig],
  components: {
    "upload-dialog": () => import("./components/uploadTarget"),
  },

  data() {
    return {
      opsHorizontal: opsHorizontal(),
      pageList: [],
      queryList: [],
      currentQuery: "",
      empty: false,
      loading: false,
      // page: 0,
      // pageSize: 50, // 本页面暂时不做分页,尽量一页显示完成
      // total: 0,
      filterData: {
        targetName: "",
      },
      isUpload: false,
      editRow: {},
      isEditMode: false,
      isUploadAll: false,
      editRowAll: {},
      isEditModeAll: false,
      isShowSaveTemp: false,
      isShowQueryBtn: true,
    };
  },

  // watch: {
  //   page(val) {
  //     console.log("in watch change page:", val);
  //     this.page = val;
  //     this.changeQuery();
  //   },
  // },
  computed: {
    tongji() {
      let tongji = {};
      for (let i in this.pageList) {
        let item = this.pageList[i];
        if (!tongji[item.targetName]) {
          tongji[item.targetName] = {
            targetName: item.targetName,
            ok: 0,
            total: 0,
          };
        }
        tongji[item.targetName].total++;
        if (item.submit) {
          tongji[item.targetName].ok++;
        }
      }
      return tongji;
    },
    tongjiAll() {
      const all = this.pageList.length;
      const pass = this.pageList.filter((i) => i.submit).length;
      return ((pass / all) * 100).toFixed(0);
    },
    showPageList() {
      return this.pageList.filter((i) => i.targetName === this.currentQuery);
    },
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid;
    },

    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid;
    },

    stageName() {
      const { stageName } = this.$route.query;
      return stageName;
    },

    isAllSubmited() {
      if (this.pageList && this.pageList.length) {
        // let status = this.pageList.some((item) => {
        //   if (!item.submit) return item.submit;
        // });
        let status = true;
        this.pageList.forEach((item) => {
          if (!item.submit) {
            status = false;
          }
        });
        return status;
      } else {
        return false;
      }
    },

    totalScore() {
      if (this.pageList.length) {
        let allScore = 0;
        this.pageList.forEach((item) => {
          const { score } = item;
          if (score !== undefined && typeof score === "number") {
            allScore += score;
          }
        });
        return allScore;
      } else {
        return 0;
      }
    },
  },

  filters: {
    empty(val) {
      if (val !== undefined) {
        return val;
      } else {
        return "--";
      }
    },
  },

  created() {
    this.setQueryData();
    this.changeQuery(true);
  },

  methods: {
    handleBack() {
      this.$router.push({
        path: "/home/index",
      });
    },
    handleAll() {
      this.isUploadAll = true;
    },
    handleSaveTemp() {
      this.isShowSaveTemp = true;
    },
    handleConfirmSaveTemp(flag) {
      if (flag) {
        this.$message.success("数据已临时保存！");
        // this.changeQuery(true); //  模拟保存，重新请求数据
        this.$router.go(-1);
      }
      this.isShowSaveTemp = false;
    },
    changeQuery(flag) {
      // flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          ...this.filterData,
          // page: this.page,
        },
      });
      this.loadPageList();
    },

    changeNav(val) {
      this.currentQuery = val;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          currentQuery: val,
        },
      });
    },

    setQueryData() {
      const { currentQuery, groupUuid, stageUuid, targetName } =
        this.$route.query;
      // String(page) && (this.page = page);
      targetName && this.$set(this.filterData, "targetName", targetName);
      currentQuery && (this.currentQuery = currentQuery);
    },

    loadPageList() {
      const { groupUuid, stageUuid, targetName } = this.$route.query;
      const paramsData = {
        groupUuid,
        stageUuid,
        // page,
        // targetSecondlyName: targetName,
        // size: this.pageSize,
      };
      this.loading = true;
      getTargetListForSubmit(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            this.empty = true;
            return;
          }
          const { targetSubmitListVos, orgAuditStageLog } = res;
          if (targetSubmitListVos.length) {
            this.pageList = targetSubmitListVos;
            // 设置nav按钮列表
            for (let i in this.pageList) {
              let item = this.pageList[i];
              if (this.queryList.indexOf(item.targetName) === -1) {
                this.queryList.push(item.targetName);
              }
            }
            // 设置默认项
            if (!this.currentQuery) {
              this.currentQuery = this.queryList[0];
            }
            // 设置是否驳回项; 如果驳回则允许修改；否则不允许提交
            if (orgAuditStageLog) {
              try {
                let { amend } = orgAuditStageLog;
                var denyList = [];
                if (amend) denyList = JSON.parse(amend);
              } catch (err) {
                console.error("err", err);
              }
              this.pageList = this.pageList.map((item) => {
                if (denyList.length) {
                  if (denyList.includes(item.uuid)) {
                    return {
                      ...item,
                      canEdit: true,
                    };
                  } else {
                    return {
                      ...item,
                      canEdit: false,
                    };
                  }
                } else {
                  return {
                    ...item,
                    canEdit: false,
                  };
                }
              });
            } else {
              this.pageList = this.pageList.map((item) => {
                return {
                  ...item,
                  canEdit: true,
                };
              });
            }

            // 设置搜索栏
            this.setQuerySelect();
            this.empty = false;
          } else {
            this.empty = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },

    loadSourceData() {
      const { groupUuid, stageUuid, targetName } = this.$route.query;
      const paramsData = {
        groupUuid,
        stageUuid,
        // page,
        // targetSecondlyName: targetName,
        // size: this.pageSize,
      };
      getTargetListForSubmit(paramsData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            this.empty = true;
            return;
          }
          const { targetSubmitListVos, orgAuditStageLog } = res;
          this.pageList = targetSubmitListVos;
          // 设置是否驳回项; 如果驳回则允许修改；否则不允许提交
          if (orgAuditStageLog) {
            try {
              let { amend } = orgAuditStageLog;
              var denyList = [];
              if (amend) denyList = JSON.parse(amend);
            } catch (err) {
              console.error("err", err);
            }
            this.pageList = this.pageList.map((item) => {
              if (denyList.length) {
                if (denyList.includes(item.uuid)) {
                  return {
                    ...item,
                    canEdit: true,
                  };
                } else {
                  return {
                    ...item,
                    canEdit: false,
                  };
                }
              } else {
                return {
                  ...item,
                  canEdit: false,
                };
              }
            });
          } else {
            this.pageList = this.pageList.map((item) => {
              return {
                ...item,
                canEdit: true,
              };
            });
          }
        })
        .catch((err) => {
          this.empty = true;
          console.error("err", err);
        });
    },

    // 提交资料
    handleCheckTarget(row) {
      this.editRow = row;
      this.isEditMode = false;
      this.isUpload = true;
    },

    // 编辑考核
    handleEditRow(row) {
      this.editRow = row;
      this.isEditMode = true;
      this.isUpload = true;
    },

    // 提交弹窗回掉方法
    handleUploadCallBack(dialogStatus, confirmStatus) {
      this.isUpload = dialogStatus;
      if (confirmStatus) {
        if (!dialogStatus) {
          // this.changeQuery(true);
          this.editRow = {};
          this.isEditMode = false;
        } else {
          console.warn("call back error, dialog will be stay!");
        }
      } else {
        this.editRow = {};
      }
      this.loadSourceData();
    },

    // 保存全部
    handleUploadCallBackAll(confirmStatus) {
      if (confirmStatus) {
        const postData = {
          groupUuid: this.groupUuid,
          stageName: this.stageName,
          stageUuid: this.stageUuid,
          totalProgress: this.tongjiAll, //
        };
        postTargetSumitAll(postData)
          .then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              return;
            }
            this.isUploadAll = false;
            this.$message.success("资料已提交！");
            this.$router.push({
              path: "/home/index",
            });
          })
          .catch((err) => {
            console.error("err", err);
          });
      } else {
        this.isUploadAll = false;
      }
    },

    handleLeft() {
      this.$refs["scrollDom"].scrollBy({
        dx: -40,
      });
    },

    handleRight() {
      this.$refs["scrollDom"].scrollBy({
        dx: 40,
      });
    },

    setQuerySelect() {
      this.$nextTick(() => {
        const dom = this.$refs["scrollWrapper"];
        if (dom.offsetWidth > 700) {
          this.isShowQueryBtn = true;
        } else {
          this.isShowQueryBtn = false;
        }
      });
    },

    // 跳转
    toPath() {
      this.$router.push({
        path: "phaselist",
        query: {
          activeCom: "document-library",
        },
      });
    },

    // 去申报评估考核阶段首页
    toUploadHome() {
      this.$router.push({
        path: "uploadHome",
        query: {
          groupUuid: this.groupUuid,
          stageUuid: this.stageUuid,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
  .select_wrap
    padding 20px 40px 20px
    min-height 40px
    display flex
    justify-content space-between
    width 100%
    .nav-btn
      width 50px
      display flex
      align-items center
      justify-content center
      cursor pointer
    .tag-box
      // flex 1
      width 680px
      margin 0 auto
      .scroll-wrapper
        display flex
        align-items center
        justify-content flex-start
        position absolute
    .tag-box1
      flex 1
      height 40px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 450px
      padding-bottom 15px
    /* flex 1 */
    /* overflow hidden */
    .tbodyWrap
      display block
    // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        // height 49px
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      // height 100%
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        padding 3px 2px
        color $color_white
        white-space pre-line
.seq
  width 6%
.stageName
  width 20%
  // width 31%
.targetTotalScore
  width 7%
.score
  width 10%
.targetRemark
  width 36%
  padding 3px 5
  white-space pre-line
.targetRemark1
  width 45%
  padding 3px 5
  white-space pre-line
.targetSuggest
  // width 10%
  flex 1
  .active
    color $green_color !important
.action
  width 10%
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
.doubleTitle
  display flex
  justify-content center
  align-items center
  flex-direction column
  p
    text-align center
    width 100%
    white-space pre-line
    // white-space nowrap
    // overflow hidden
    // text-overflow ellipsis
  .upTitle
    color $green_color !important
.footer-tips
  padding 0px 0px
  display flex
  align-items center
  justify-content flex-end
/deep/.el-input__inner
  border-radius 0px
.un-submit, .un-edit
  color $green_color
  cursor not-allowed
</style>

<style lang="stylus">
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>
